import { render } from "./createnewversion.vue?vue&type=template&id=3c108502&scoped=true"
import script from "./createnewversion.vue?vue&type=script&lang=js"
export * from "./createnewversion.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createnewversion.vue?vue&type=style&index=1&id=3c108502&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c108502"]])

export default __exports__